<template>
    <form-accordion
        name="contract-information"
        section="Contract Information"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <listing-type
            :deal="property.deal"
            :read_only="read_only"
        />

        <listing-numbers
            :deal="property.deal"
            :read_only="read_only"
        />

        <purchase-price
            :read_only="read_only"
        />

        <contract-date
            :read_only="read_only"
        />

        <inspection
            :inspection="property.inspection"
            :read_only="read_only"
        />

        <attorney-review
            :attorney="property.attorney"
            :read_only="read_only"
        />

        <mortgage-contingency
            :mortgage="property.mortgage"
            :read_only="read_only"
        />

        <closing-date
            :read_only="read_only"
        />

        <titleease-order-tile
            v-if="titleease_enabled"
            :property="property"
            :order_title_route="order_title_route"
            :order_status_route="order_status_route"
            :contract_documents_route="contract_documents_route"
            :read_only="read_only"
        />

        <who-pays-title
            :deal="property.deal"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import ListingType from './listing-type.vue';
import ListingNumbers from './listing-numbers.vue';
import PurchasePrice from './purchase-price.vue';
import ContractDate from './contract-date.vue';
import Inspection from './inspection.vue';
import AttorneyReview from './attorney-review.vue';
import MortgageContingency from './mortgage-contingency.vue';
import ClosingDate from './closing-date.vue';
import WhoPaysTitle from './who-pays-title.vue';
import TitleeaseOrderTile from '../../referrals/titleease/titleease-order-tile.vue';

export default {
    components: {
        ListingType,
        ListingNumbers,
        PurchasePrice,
        ContractDate,
        Inspection,
        AttorneyReview,
        MortgageContingency,
        ClosingDate,
        WhoPaysTitle,
        TitleeaseOrderTile,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
        order_title_route: {},
        order_status_route: {},
        contract_documents_route: {},
        titleease_enabled: { default: false },
    },
}
</script>
